import { useNuxtApp, useRouter } from 'nuxt/app'
import { parseURL } from '~/plugins/url'

export const navigateValidDeepLink = (url: string) => {
  const app = useNuxtApp()
  const router = useRouter()
  if (!router || !url) return

  // get pathname from url
  const { protocol, hostname, pathname } = parseURL(url)
  if (!pathname) return

  // check if path is valid
  const result = router.resolve(pathname)
  if (result.resolved.matched.length === 0) return

  app.$mixpanel?.trackDeepLinkEvent({
    Link: url,
    Protocol: protocol,
    Hostname: hostname,
    Pathname: pathname
  })
  router.push(pathname)
}
